import { mySkills } from "./skills";

export const aboutMePageData = {
    aboutData: [
        {
            id: 1,
            text: `I'm a Software Engineer with 4+ years of experience building modern, scalable, and high-performance web applications using React.js, Next.js, and TypeScript. I enjoy creating clean user interfaces, writing maintainable code, and delivering solutions that provide an excellent user experience.`,
        },
        {
            id: 2,
            text: `Currently, I work at Akij IBOS Limited, where I develop enterprise-level web applications using React.js, Next.js, TypeScript, Redux Toolkit, and REST APIs. Previously, I worked at JS Template, contributing to a Job Management Portal built with Next.js, Strapi, and TurboRepo, and at RBS Tech LTD, where I developed ERP modules including project management, real-time chat, Kanban boards, task management, invoicing, VAT & TAX, calendars, and role-based access control.`,
        },
        {
            id: 3,
            text: `My expertise includes JavaScript, TypeScript, React.js, Next.js, Redux Toolkit, RTK Query, Node.js, Express.js, Strapi, MongoDB, Material UI, Tailwind CSS, and Git. I enjoy solving complex problems, collaborating with cross-functional teams, and continuously learning new technologies to build reliable and scalable software.`,
        },
    ],

    mySkills: mySkills,

    funFact: [
        "4+ Years of Professional Experience",
        "React.js, Next.js & TypeScript Specialist",
        "Enterprise Application Developer",
        "REST API & State Management Expert",
        "Responsive & Performance-First Development",
        "Component-Driven Architecture Advocate",
        "Clean Code & Best Practices Enthusiast",
        "Agile Team Collaboration",
        "Continuous Learning Mindset",
        "Problem Solver & Detail-Oriented Developer",
    ],
    overleafResume: "https://www.overleaf.com/read/xbkhmhgtfmts#a92042",
    image: require("../assets/images/sohanFormal-2.jpg"),
};

export const homeAboutSectionData = {
    aboutData: [
        {
            id: 1,
            text: `Hi! I'm MD. Abdul Kader, a Software Engineer specializing in React.js, Next.js, and TypeScript. I have 4+ years of experience building scalable, responsive, and user-friendly web applications with a strong focus on performance, clean architecture, and maintainable code.`,
        },
        {
            id: 2,
            text: `Currently, I'm working as a Software Engineer at Akij IBOS Limited. I have experience developing enterprise applications, ERP systems, and modern web platforms using React.js, Next.js, Redux Toolkit, Strapi, Node.js, and REST APIs. I'm passionate about learning new technologies and building products that create real business value.`,
        },
    ],

    overleafResume: "https://www.overleaf.com/read/xbkhmhgtfmts#a92042",
    image: require('../assets/images/heroAboutMEImg.jpeg'),
};